import { Navigate, Outlet, useLocation } from "react-router-dom";
import { canEdit } from "../../utils/permissions";

const EditOnlyRouteGuard = () => {
    const location = useLocation();

    const pathSegments = location.pathname.split("/");
    const isAddRoute = pathSegments.includes("add");

    if (isAddRoute && !canEdit()) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default EditOnlyRouteGuard;
